import { render, staticRenderFns } from "./RevenueCountryWise.vue?vue&type=template&id=e52780e4&"
import script from "./RevenueCountryWise.vue?vue&type=script&lang=js&"
export * from "./RevenueCountryWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports